import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5fb6fc29&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fb6fc29')) {
      api.createRecord('5fb6fc29', component.options)
    } else {
      api.reload('5fb6fc29', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5fb6fc29&", function () {
      api.rerender('5fb6fc29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configuration/basic/index.vue"
export default component.exports